<script>
    export default {
        props: {
            initialDeliveryPhase: {
                type: Object,
                required: true,
            },
            companyPhases: {
                type: Array,
                required: false,
                default: () => [],
            },
            canEdit: {
                type: Boolean,
                required: false,
                default: true,
            },
        },

        data() {
            return {
                deliveryPhase: this.initialDeliveryPhase,
            };
        },

        methods: {
            updateDeliveryPhase() {
                window.location = window.location.href;
            },
            isCompanyPhase(phase) {
                return this.companyPhases.indexOf(phase) >= 0;
            },
        },
    };
</script>
